// extracted by mini-css-extract-plugin
export default {"btop":"_05f744389e _8ff81e7f1a _59d6c90216","icon":"ee865b4f7a _9533abcc9e","btoppink":"_6a5f905c47 _38869cc22d"};